import { v4 as uuid } from "uuid";
import { injectIntl } from "react-intl";
import { intlShape, userShape } from "../../shapes";
import PlanVariantAddonsGroup from "../PlanVariants/PlanVariantAddonsGroup";
import { withConfiguration } from "../../context";
import { priceDisplayFormat } from "../../utils/priceUtils";
import { withUser } from "../../wrappers";

type Props = {
  planVariant?: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string;
    type?: string;
    sort?: number;
    popular?: boolean;
    button?: string;
    assets?: number;
    storage?: number;
    short_description?: string;
    features?: string[];
    addons?: $TSFixMe[];
  };
  intl: intlShape;
  configuration?: {
    planPriceDisplay?: string;
  };
  user: userShape;
};

export function UnavailablePlan(props: Props) {
  const { planVariant, intl, configuration, user } = props;
  const panelClass = "panel panel-default panel-disabled";

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const features = planVariant.features.map((item) => (
    <li className="list-item-checked" key={uuid()}>
      {item}
    </li>
  ));
  const planPriceDisplayYearly = configuration?.planPriceDisplay === "yearly";
  const planUnitText = intl.formatMessage({ id: "planvariant.per_user" });
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const planVariantPrice = parseFloat(planVariant.price);
  const displayPrice = priceDisplayFormat(
    intl,
    planVariantPrice,
    planPriceDisplayYearly,
    planVariant?.currency,
    planUnitText,
  );
  const price =
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    planVariant.type === "free" || planVariantPrice === 0
      ? intl.formatMessage({ id: "planvariant.free" })
      : displayPrice;

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const shortDescription = planVariant.short_description ? (
    <div id="short-description" className="space-after short-description">
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {planVariant.short_description}
    </div>
  ) : null;

  return (
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    <div id={`plan-variant-${planVariant.id}`} className={panelClass}>
      <div className="panel-heading">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {planVariant.name}
        <div id="price" className="panel-heading panel-subtitle">
          {price}
        </div>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {planVariant.type === "free" || planVariantPrice === 0 ? null : (
          <p className="panel-subtitle">
            {intl.formatMessage({ id: "planvariant.billed_annually" })}
          </p>
        )}
      </div>
      <div className="panel-body">
        {shortDescription}
        <ul id="plan-variant-features" className="list-checked">
          {features}
        </ul>
        <div>
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            user={user}
            types={["outcome"]}
            groupId="outcome"
            titleId="planvariant.outcome"
            intl={intl}
            disabled
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            user={user}
            types={["connectivity"]}
            groupId="connectivity"
            titleId="planvariant.connectivity"
            intl={intl}
            disabled
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            user={user}
            types={["process_insights"]}
            groupId="process-insights"
            titleId="planvariant.process_insights"
            intl={intl}
            disabled
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            user={user}
            types={["addon", "extension"]}
            groupId="standard"
            titleId="planvariant.addons"
            intl={intl}
            disabled
          />
        </div>
      </div>
    </div>
  );
}

export default injectIntl(withUser(withConfiguration(UnavailablePlan)));
